import { Component, Inject, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core'
import { CommonService }from '../../../core/services/common.service'

@Component({
    selector: 'ca-loading',
    templateUrl: './loading.component.html',
    standalone: false
})
export class LoadingComponent implements OnInit, OnChanges {
    @Input() loadText: string
    @Input() loadState: boolean
    @Input() loaderType: 'parcels' | 'spinner' = 'spinner'
    @Input() loaderEffect: 'shimmer' | 'scanline' | 'drawBorders' | 'sequential' = 'shimmer'

    constructor(@Inject(CommonService) private commonService: CommonService) {
    }

    ngOnInit(): void {
        if (!this.loadText) {
            this.loadText = 'Načítám data...'
        }
    }

    ngOnChanges(changes: SimpleChanges) {
        for (const key in changes) {
            if (Object.prototype.hasOwnProperty.call(changes, key)) {
                switch (key) {
                    case 'loadState':
                        this.commonService.clearHangingTooltips()
                        break
                }
            }
        }
    }

}